import { WeblinkCard, WeblinkCardActionArea } from './weblink.styles'
import {
  Box,
  Container,
  IconButton,
  ListItem,
  ListItemButton,
  ListItemText,
  Menu,
  MenuItem,
  Typography,
} from '@common/components'
import MoreHorizIcon from '@mui/icons-material/MoreHoriz'
import { useToggle, useTranslation } from '@common/hooks'
import useToggleMenu from '@common/hooks/use-toggle-menu'
import WeblinkModal from '../weblink-modal'
import { useWeblinksDeleteWeblinkMutation } from '@app/services/auto-generated/weblinks'
import URL from 'url-parse'

const Weblink = (props) => {
  const { title, url, id, tags } = props
  const { open, anchorEl, handleClose, handleClick } = useToggleMenu()
  const { open: openModal, handleClose: closeModal, handleOpen } = useToggle(false)
  const { t } = useTranslation()
  const [deleteWeblink] = useWeblinksDeleteWeblinkMutation()
  const handleDelete = async () => {
    try {
      await deleteWeblink({ weblinkId: id }).unwrap()
    } catch (error) {}
  }

  const handleLinkClick = (e) => {
    e.preventDefault()
    let parsedUrl
    if (url.startsWith('http://') || url.startsWith('https://')) {
      parsedUrl = new URL(url)
    } else {
      parsedUrl = new URL('http://' + url)
    }
    window.open(parsedUrl.href, '_blank')
  }

  // return (
  //   <ListItem
  //     secondaryAction={
  //       <IconButton edge="end" aria-label="comments">
  //         t
  //       </IconButton>
  //     }
  //     disablePadding
  //   >
  //     <ListItemButton role={undefined} dense>
  //       <ListItemText primary={`Line item `} />
  //     </ListItemButton>
  //   </ListItem>
  // )

  return (
    <Container>
      <WeblinkModal
        modify
        open={openModal}
        handleClose={closeModal}
        weblinkId={id}
        weblinkTitle={title}
        weblinkLink={url}
        weblinkTags={tags}
      />
      <WeblinkCard>
        <WeblinkCardActionArea onClick={handleLinkClick}>
          <Typography noWrap>{title}</Typography>
          <Typography noWrap sx={{ maxWidth: '120px' }}>
            {url}
          </Typography>
        </WeblinkCardActionArea>
        <Box sx={{ width: '80px', flex: 1 }}>
          <IconButton onClick={handleClick}>
            <MoreHorizIcon />
          </IconButton>
          <Menu
            elevation={1}
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'right',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
          >
            <MenuItem onClick={handleOpen}>
              <Typography variant='body1' align='center' sx={{ px: 4, py: 1 }}>
                {t('weblink.modify', 'Modify')}
              </Typography>
            </MenuItem>
            <MenuItem onClick={handleDelete}>
              <Typography variant='body1' align='center' sx={{ px: 4, py: 1 }}>
                {t('weblink.delete', 'Delete')}
              </Typography>
            </MenuItem>
          </Menu>
        </Box>
      </WeblinkCard>
    </Container>
  )
}

export default Weblink
